import React, {Component} from 'react';
import { withRouter } from "react-router-dom";




class LostAndFound extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Lost And Found </h2>

                <br/>
               

                <h6> Using the Lost And Found Screen </h6>
                <p className='text-primary'>
                    The lost and found inventory screen is the main area to find items and filter the status of lost and found items. Users can use this screen to quickly locate items within a lost and found by sorting filtering or searching. When the gas calls asking for information regarding a found item this will be the screen two years.
                 </p>
              
                <br/><br/><br/>
                <div className="text-center">
                <img className='text-center' style={{width:"80%", height:"80%"}} src='./images/lostandfound.png'  alt=''/> 
              
                   
                </div>
               
              <p className='text-primary'>
                    <h6>Filtering:</h6>
                    You can filter the list of lost items under five categories you can list everything unclaimed claimed returned or archived. These buttons are located along the top. Clicking on any of those buttons will apply the filter and immediately fell to the list. For example. Clicking the unclaimed button will filter out all lost items that or not unclaimed.
                    <br/><br/>
                    <h6>Searching:</h6>
                    The search text box is located along the top of the lost and found list. To search the list typed the first few characters of the keyword or item description at best would with match with your search criteria S. This system for auto filter The list immediately.
                    <br/><br/>
                    <h6>Sorting:</h6>
                    Clicking on the column headers will sort ASC/DESC for any of the supported columns.  
                    <br/><br/>
                    <h6>Pagination:</h6>
                    The lost &amp; found items will default to 10 items. Locate the pagination button toward the bottom left-hand of the screen. Here you adjust how many items to display.  You can select the page, previous, and next pages 
                    by clicking the lower-right menu items.

                </p>
                
            </div>
        )
       


    }

}
export default withRouter(LostAndFound);
